import React, { useEffect, useState } from 'react';

import FatigueAssessmentPage from "./FatigueAssessmentPage";
import { shiftSummaryDashboardPending } from "./FatigueAssessmentPageSelector";
import FatigueAssessmentCardList from "./FatigueAssessmentCardList";
import { FatigueAssessmentView } from './FatigueAssessmentView';
import { ISelectOption } from '../forms/util';

interface FatigueAssessmentDashboardProps {
    page: ISelectOption,
    pageView: FatigueAssessmentView
}

const FatigueAssessmentDashboard = (props: FatigueAssessmentDashboardProps) => {
    const [selectedPage] = useState(props.page ?? shiftSummaryDashboardPending);
    const [pageView] = useState(props.pageView ?? FatigueAssessmentView.Pending);

    const getPageTitle = () => {
        var title = selectedPage.label;
        return title;
    }

    const pageTitle = getPageTitle();

    return (
        <FatigueAssessmentPage key={selectedPage.value} selectedPage={selectedPage}>
            <div className="fa-list-container">
                <FatigueAssessmentCardList
                    view={[pageView]}
                    title={pageTitle}
                    showPageSize={true}
                    showFilters={true}
                    showFooter={true}
                />
            </div>
        </FatigueAssessmentPage>
    );
}

export default FatigueAssessmentDashboard;
